import { render, staticRenderFns } from "./CommunicationEmailPopup.vue?vue&type=template&id=570225f0"
import script from "./CommunicationEmailPopup.vue?vue&type=script&lang=ts"
export * from "./CommunicationEmailPopup.vue?vue&type=script&lang=ts"
import style0 from "./CommunicationEmailPopup.vue?vue&type=style&index=0&id=570225f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports